import 'whatwg-fetch'

import userLoggedIn from './dummy-data/userLoggedIn'
import customersList from './dummy-data/customersList'
import customersDetail from './dummy-data/customersDetail'
import invitesList from './dummy-data/invitesList'

const artificialGetDelay = 500
const artificialPostDelay = 600

const headers = {
  'Content-Type': 'application/json',
  'device-id': 'react-testing',
}

const LOCAL_PREFIX = process.env.NODE_ENV === 'notYetWiP' ? '' : 'https://silver-pact-230806.appspot.com'

export const fakeApi = {
  get: path => {
    let status = 200
    let dataResponse = null

    switch (true) {
      case /accountant\/[A-z-0-9]+\/customers\/[A-z-0-9]+\/invoices/.test(path):
        dataResponse = customersDetail
        break

      case /accountant\/[A-z-0-9]+\/customers/.test(path):
        dataResponse = customersList
        break

      case /accountant\/[A-z-0-9]+\/invites/.test(path):
        dataResponse = invitesList
        break

      default:
        status = 404
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (dataResponse) {
          resolve({status, data: dataResponse, json: () => ({then: c => c(dataResponse)}), ok: true})
        } else {
          reject(new Error('Request failed (404)'))
        }
      }, artificialGetDelay)
    })
  },

  post: (path, data) => {
    let status = 200
    let dataResponse = null

    if (!data) {
      status = 422
    }

    switch (path) {
      case '/auth/refreshToken':
      case '/auth/email':
      case '/users':
        dataResponse = userLoggedIn
        break

      default:
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (status >= 400) {
          reject(new Error(`Request failed with status code: ${status}`))
        } else {
          resolve({status, data: dataResponse, json: () => ({then: c => c(dataResponse)}), ok: true})
        }
      }, artificialPostDelay)
    })
  },

  patch: (path, data) => {
    let status = 200
    let dataResponse = null

    if (!data) {
      status = 422
    }

    switch (path) {
      case '/users':
        dataResponse = userLoggedIn
        break

      default:
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (status >= 400) {
          reject(new Error(`Request failed with status code: ${status}`))
        } else {
          resolve({status, data: dataResponse, json: () => dataResponse, ok: true})
        }
      }, artificialPostDelay)
    })
  },
}

const apiMethods = headers => (
  process.env.REACT_APP_FAKE_API ? fakeApi : {
    get: path => fetch(LOCAL_PREFIX + path, {headers: headers}),
    post: (path, body, stringify) => fetch(LOCAL_PREFIX + path, {
      method: 'POST',
      headers: headers,
      body: stringify ? JSON.stringify(body) : body,
    }),
    patch: (path, body, stringify) => fetch(LOCAL_PREFIX + path, {
      method: 'PATCH',
      headers: headers,
      body: stringify ? JSON.stringify(body) : body,
    }),
  }
)

export const publicApi = apiMethods(headers)

export const realApi = token => (
  apiMethods({
    ...headers,
    'access-token': token,
  })
)

export default realApi
